export enum Routes {
    HOME = '/home',
    LOGIN = '/login',
    REGISTER = '/register',
    INFORMATION = '/information',
    INICIO = '/app/inicio',
    EDIT_USER = '/app/perfil',
    ACTIVE_COURSE = '/app/course-active',
    COURSES_STUDENT_ACTIVATED = '/app/courses-student-activated',
    COURSES_STUDENT_COMPLETED = '/app/courses-student-completed',
    LIST_COURSE_APPLICANTS = '/app/course-applicants',
    EDIT_COURSE_APPLICANTS = '/app/course-applicants-form/edit',
    COURSES_VISIBLE = '/app/courses-visible',
    COURSES_INVOICE = '/app/courses-invoice/edit',
    EDIT_COURSES_INVOICE = '/app/courses-invoice-form/edit',
    ADD_COURSES_INVOICE = '/app/courses-invoice-form/add',
    EDIT_COURSE = '/app/course/edit',
    ADD_COURSE = '/app/course/add',
    LIST_PERSON = '/app/person-filter',
    ADD_PERSON = '/app/person/add',
    EDIT_PERSON = '/app/person/edit',
    LIST_ENTITY = '/app/entities',
    EDIT_ENTITY = '/app/entity/edit',
    ADD_ENTITY = '/app/entity/add',
    ENTITIES_STUDENTS = '/app/entities-students',
    ENTITIES_MAIN_TEACHER = '/app/entities-main-teacher',
    ENTITIES_MAIN_TEACHER_FORM = '/app/entities-main-teacher-form',
    EDIT_MODULE = '/app/module/edit',
    ADD_MODULE = '/app/module/add',
    EDIT_CLASS = '/app/class/edit',
    ADD_CLASS = '/app/class/add',
    EDIT_EXAM = '/app/exam/edit',
    ADD_EXAM = '/app/exam/add',
    EDIT_OPTION = '/app/option/edit',
    ADD_OPTION = '/app/option/add',
    EDIT_EXAM_QUESTION = '/app/exam-question/edit',
    ADD_EXAM_QUESTION = '/app/exam-question/add',
    EDIT_REFERENCE = '/app/reference/edit',
    ADD_REFERENCE = '/app/reference/add',
    TEMAS_DOCUMENTS = '/app/temas-documents',
    COURSES_TEACHER = '/app/courses-teacher',
    LIST_INVOICE = '/app/invoice',
    LIST_INVOICE_ENTITIES_DEBT = '/app/invoice-entities-debt',
    EDIT_INVOICE = '/app/invoice-form/edit',
    ADD_INVOICE = '/app/invoice-form/add',
    LIST_PARAMETER = '/app/config-parameter',
    EDIT_PARAMETER = '/app/config-parameter/edit',
    ADD_PARAMETER = '/app/config-parameter/add',
    LIST_TRACE = '/app/trace'
}
